<template>
  <div
    v-if="hasAjaxErrors"
    class="alert-error sticky island"
    role="alert"
    tabindex="-1"
  >
    <div class="icon">
      <div class="af-icons-md af-icons-md-alert-error"></div>
    </div>
    <div class="message">
      <p v-if="genericErrorMessage" v-html="genericErrorMessage"/>
      <p v-else v-html="lang.get('miscellaneous.alerts.validator.short_message')"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

const toastr = require('toastr');

export default {
  inject: ['lang'],

  computed: {
    ...mapGetters('entryFormApi', [ 'hasValidatorMessage', 'genericErrorMessage' ]),
    hasAjaxErrors() {
      return this.hasValidatorMessage || this.genericErrorMessage
    }
  }
};
</script>
